import React from 'react'

const ModuloPreguntas = () => {
  return (
    <div>
      Modulo preguntas
    </div>
  )
}

export default ModuloPreguntas
